import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Box from '@mui/material/Box';
import { FC } from 'react';

import { useActions } from '../../../../hooks/useActions';
import { useUser } from '../../../../hooks/useUser';
import { Logo } from '../../../Logo';
import { IAuthTypeForm } from '../../auth.interface';

import styles from './AuthHeader.module.sass';
import AuthHeaderCall from './AuthHeaderCall';
import AuthHeaderDescr from './AuthHeaderDescr';
import AuthHeaderTitle from './AuthHeaderTitle';

//Шапка формы/модалки
const AuthHeader: FC<IAuthTypeForm> = ({ type }) => {
  const { setAuthVisible, setFormType } = useActions();
  const { visibleAuthDialog } = useUser();

  return (
    <Box className={styles.top}>
      <div className={styles.header}>
        <Logo />
        <AuthHeaderTitle type={type} />
        <AuthHeaderDescr type={type} />
        {type === 'code' && <AuthHeaderCall />}
      </div>
      <CloseRoundedIcon
        className={styles.close}
        fontSize="large"
        color="disabled"
        onClick={() => {
          // Закрываем модальное окно и при след. открытии будет форма ввода телефона
          setFormType('phone');
          setAuthVisible(!visibleAuthDialog);
        }}
      />
    </Box>
  );
};

export default AuthHeader;
